<template>
  <div class="home-v2">
    <Loading v-if="$store.state.globalLoading" />
    <div class="request-container">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  components: {
    Loading: () => import('@/components/V2/GlobalLoading'),
  },
  data() {
    return {
      modalOpen: false,
    }
  },
}
</script>
